
import React, { useEffect, useState } from "react";
import { BASE_API_URL, BASE_IMAGE_API_URL } from "../services/baseServices";
import MainLayout from "../layouts/MainLayout";
import { Popover } from 'antd';
import Swal from 'sweetalert2';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import '../assets/styles/loader.css';
import '../assets/styles/pagination.css';
import ViewContentByType from "../components/contentByType/view";
import AddContentByType from "../components/contentByType/add";
import EditContentByType from "../components/contentByType/edit";
import { GET_DDL_ITEMS } from "../services/commonServices";
import axios from "axios";
import { Select } from 'antd';
import { GET_CONTENT_BY_TYPE } from "../services/contentByTypeServices";
import { useNavigate } from "react-router-dom";
import { fetchOrganizations } from "../services/organizationServices";

export default function ContentByTypeList () {

    const navigate = useNavigate();
    const [sessionUserData, setSessionUserData] = useState([]);
    const [contentByTypeData, setContentByTypeData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [editData, setEditData] = useState([]);
    const [viewData, setViewData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedOrgType, setSelectedOrgType] = useState(null);
    const [selectedContentType, setSelectedContentType] = useState(null);
    const [contentTypeData, setContentTypeData] = useState([]);
    const [organizationsData, setOrganizationsData] = useState([]);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setSessionUserData(userData);
        } else {
            navigate("/");
        }
    }, [navigate]);

     const getOrganizations = async () => {
            try {
                const data = await fetchOrganizations();
                setOrganizationsData(data);
            } catch (error) {
                console.error('Failed to load organizations:', error);
            } finally {
                console.log('Organization fetch completed');
            }
        };
    
        useEffect(() => {
            getOrganizations();
        }, []);

    const handleFilter = async () => {
        setDataLoading(true);
        if (!selectedOrgType && !selectedContentType) {
            alert("Please choose both Organization and Content Type..!");
            setDataLoading(false);
            return;
        }

        if (selectedContentType && !selectedOrgType) {
            alert("Please choose Organization..!");
            setDataLoading(false);
            return;
        }

        if (!selectedContentType && selectedOrgType) {
            alert("Please choose Content Type..!");
            setDataLoading(false);
            return;
        }
        if (selectedOrgType && selectedContentType) {
            try {
                const response = await fetch(`${BASE_API_URL}${GET_CONTENT_BY_TYPE}?OrgId=${selectedOrgType}&Type=${selectedContentType}`);
                if (response.ok) {
                    const data = await response.json();
                    setContentByTypeData(data.ResultData);
                    // console.log(data.ResultData);
                } else {
                    setDataLoading(false);
                    console.error('Failed to fetch attendance data:', response.statusText);
                }
            } catch (error) {
                setDataLoading(false);
                console.error('Error fetching attendance data:', error.message);
            } finally {
                setDataLoading(false);
            }
        }
    };

    useEffect(() => {
        if (selectedOrgType) {
            fetchContentType();
        }
    }, [selectedOrgType]);

    const fetchContentType = async (type) => {
        try {
            const response = await axios.get(`${BASE_API_URL}${GET_DDL_ITEMS}?OrgId=${selectedOrgType}&UserId=${sessionUserData?.Id}`);
            const allItems = response.data.ResultData;

            const contentTypesRes = allItems.filter(item => item.DDLName === "ContentTypes");

            setContentTypeData(contentTypesRes);
        } catch (error) {
            console.error(`Error fetching ${type}:`, error);
            return null;
        }
    };

    const filteredData = contentByTypeData && contentByTypeData.filter((item) => {
        const title = item?.Title?.toLowerCase() || '';
        const description1 = item?.Description1?.toLowerCase() || '';
        const description2 = item?.Description2?.toLowerCase() || '';

        const query = searchQuery.toLowerCase();

        return (
            title.includes(query) ||
            description1.includes(query) ||
            description2.includes(query)
        );
    });

    const handleOrgChange = (e) => {
        setSelectedOrgType(e.target.value);
    };

    const handleTypeChange = (e) => {
        setSelectedContentType(e.target.value);
    };

    const handleEdit = (item) => {
        setEditData(item);
    };

    const handleView = (item) => {
        setViewData(item);
    };

    const handleDelete = async (item) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this content?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const now = new Date();
                    const currentTime = `${now.getFullYear()}-${String(
                        now.getMonth() + 1
                    ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
                        now.getHours()
                    ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
                        now.getSeconds()
                    ).padStart(2, "0")}.000`;

                    const payload = {
                        UpdatedBy: sessionUserData.Id,
                        Id: item.Id
                    };

                    const response = await fetch(`${BASE_API_URL}UsersInActive`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payload),
                    });
                    const result = await response.json();
                    console.log(result)
                    if (result.ResultData[0].Status === 'Success') {
                        Swal.fire("Success!", "User has been deleted.", "success");
                    } else {
                        const errorData = await response.json();
                        Swal.fire("Error!", errorData.message || "Failed to delete user.", "error");
                    }
                } catch (error) {
                    console.error("Error during user delete:", error.message);
                    Swal.fire("Error!", "An unexpected error occurred.", "error");
                }
            }
        });
    };

    const imageStyle = {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        objectFit: 'cover',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
        cursor: 'pointer',
        border: '2px solid #e0f2fe',
        backgroundColor: '#fff'
    };
   
    const recordsPerPage = 5;
    const totalPages = Math.ceil(filteredData?.length / recordsPerPage);

    // Get current records to display
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData?.slice(indexOfFirstRecord, indexOfLastRecord);

    const getPaginationNumbers = () => {
        const visiblePages = [];
        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) visiblePages.push(i);
        } else {
            if (currentPage <= 3) {
                visiblePages.push(1, 2, 3, "...", totalPages - 2, totalPages - 1, totalPages);
            }
            else if (currentPage > 3 && currentPage < totalPages - 2) {
                visiblePages.push(1, 2, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages - 1, totalPages);
            }
            else {
                visiblePages.push(1, 2, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            }
        }
        return visiblePages;
    };

    const handlePageClick = (page) => {
        if (page !== "...") setCurrentPage(page);
    };

    const handlePrevious = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    return (
        <MainLayout>
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4 className="fw-bold">Content By Type</h4>
                            <h6>Manage your contents by type</h6>
                        </div>
                    </div>
                    <ul className="table-top-head">
                        {/* <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="assets/img/icons/pdf.svg" alt="img"/></a>
                        </li>
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="assets/img/icons/excel.svg" alt="img"/></a>
                        </li> */}
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i className="ti ti-refresh"></i></a>
                        </li>
                        
                    </ul>
                    <div className="page-btn">
                        <a href="#" className="btn btn-primary"  
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightAdd"
                            aria-controls="offcanvasRightAdd">
                                <i className="ti ti-circle-plus me-1"></i>New Content
                        </a>
                    </div>
                </div>
                
                <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <div className="search-set">
                            <div className="search-input">
                                <span className="btn-searchset"><i className="ti ti-search fs-14 feather-search"></i></span>
                                <input type="search" className="form-cotrol" placeholder="Search"/>
                            </div>
                        </div>
                        <div className="table-dropdown my-xl-auto right-content">
                            <div
                                className="d-flex flex-column flex-lg-row justify-content-lg-end justify-content-between align-items-end "
                                data-kt-customer-table-toolbar="base"
                            >
                                <div
                                    className={`d-flex flex-column me-3 mb-3 mb-md-0`}
                                >
                                    <label className="form-label">Organization</label>
                                    <Select
                                        showSearch
                                        placeholder="Choose organization"
                                        optionFilterProp="children"
                                        value={selectedOrgType}
                                        onChange={(value) => setSelectedOrgType(value)}
                                        filterOption={(input, option) =>
                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        style={{ width: '100%' }}
                                    >
                                        {organizationsData?.map((item) => (
                                            <Select.Option key={item.OrgId} value={item.OrgId}>
                                                {item.OrgName}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>
                                <div className="d-flex flex-column me-3 mb-3 mb-md-0">
                                    <label className="form-label">Content Type</label>
                                    <Select
                                        showSearch
                                        placeholder="Choose type"
                                        optionFilterProp="children"
                                        value={selectedContentType}
                                        onChange={(value) => setSelectedContentType(value)}
                                        filterOption={(input, option) =>
                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        style={{ width: '100%' }}
                                    >
                                        {contentTypeData?.map((item) => (
                                        <Select.Option key={item.ItemId} value={item.DisplayValue}>
                                            {item.DisplayValue}
                                        </Select.Option>
                                        ))}
                                    </Select>
                                </div>
                                <button
                                    className="btn btn-info"
                                    onClick={handleFilter}
                                    disabled={dataLoading}
                                >
                                    <i className="fa-solid fa-filter"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="no-sort">#</th>
                                        <th>Title</th>
                                        <th className="text-center">Description1</th>
                                        <th className="text-center">Description2</th>
                                        <th>Image1</th>
                                        <th>Icon</th>
                                        <th>Status</th>
                                        <th className="no-sort">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="fw-semibold text-gray-600">
                                        {dataLoading ? (
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <div className="container"></div>
                                                </td>
                                            </tr>
                                        ) : currentRecords && currentRecords.length > 0 ? (
                                            currentRecords?.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                                                    <td>
                                                        <a
                                                            className="text-gray-800 text-hover-primary mb-1"
                                                            title={item.Title}
                                                        >
                                                            {item.Title.length > 20 ? `${item.Title.slice(0, 20)}...` : item.Title}
                                                        </a>
                                                    </td>
                                                    <td className="text-center">
                                                        <i
                                                            className="fa-solid fa-message fa-lg"
                                                            data-tooltip-id={`desc-tooltip1-${item.Id}`}
                                                            data-tooltip-html={item.Description1}
                                                            style={{ cursor: 'pointer' }}
                                                        ></i>

                                                        <Tooltip
                                                            id={`desc-tooltip1-${item.Id}`}
                                                            html={true}
                                                            place="top"
                                                            style={{
                                                            maxWidth: '200px',
                                                            whiteSpace: 'normal',
                                                            textAlign: 'left',
                                                            padding: '8px',
                                                            borderRadius: '6px',
                                                            backgroundColor: '#e0f2fe',
                                                            color: '#0c4a6e',
                                                            fontSize: '13px',
                                                            border: '1px solid #bae6fd'
                                                            }}
                                                        />
                                                    </td>

                                                    <td className="text-center">
                                                        <i
                                                            className="fa-solid fa-message fa-lg"
                                                            data-tooltip-id={`desc-tooltip2-${item.Id}`}
                                                            data-tooltip-html={item.Description2}
                                                            style={{ cursor: 'pointer' }}
                                                        ></i>

                                                        <Tooltip
                                                            id={`desc-tooltip2-${item.Id}`}
                                                            html={true}
                                                            place="top"
                                                            style={{
                                                            maxWidth: '200px',
                                                            whiteSpace: 'normal',
                                                            textAlign: 'left',
                                                            padding: '8px',
                                                            borderRadius: '6px',
                                                            backgroundColor: '#e0f2fe',
                                                            color: '#0c4a6e',
                                                            fontSize: '13px',
                                                            border: '1px solid #bae6fd'
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="text-info">
                                                        <img
                                                            src={`${BASE_IMAGE_API_URL}${item.ImageUrl1}`}
                                                            alt="Img"
                                                            style={imageStyle}
                                                            data-bs-toggle="modal"
                                                            data-bs-target={`#imageModal-${item.Id}`}
                                                        />
                                                    </td>
                                                    <td>
                                                        {item.IconName ? (
                                                            <div
                                                                className="icon"
                                                                dangerouslySetInnerHTML={{ __html: item.IconName }}
                                                            ></div>
                                                        ) : (
                                                            <span>No Icon</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className={`badge bg-soft-${item.IsActive ? 'success' : 'danger'}`}>
                                                            {item.IsActive ? 'Active' : 'In-Active'}
                                                        </div>
                                                    </td>
                                                    <td className="">
                                                        <Popover
                                                            placement="bottom"
                                                            content={
                                                                <div style={{ width: '8rem' }}>
                                                                    <p
                                                                        style={{ cursor: 'pointer' }}
                                                                        className="text-hover-warning"
                                                                        data-bs-toggle="offcanvas"
                                                                        data-bs-target="#offcanvasRightView"
                                                                        aria-controls="offcanvasRightView"
                                                                        onClick={() => handleView(item)}

                                                                    ><i className="fa-regular fa-eye me-2 text-primary"></i>View</p>
                                                                    <p
                                                                        style={{ cursor: 'pointer' }}
                                                                        className="text-hover-warning"
                                                                        data-bs-toggle="offcanvas"
                                                                        data-bs-target="#offcanvasRightEdit"
                                                                        aria-controls="offcanvasRightEdit"
                                                                        onClick={() => handleEdit(item)}
                                                                    >
                                                                        <i className="fa-regular fa-pen-to-square me-2 text-info"></i>
                                                                        Edit
                                                                    </p>
                                                                    <p
                                                                        style={{ cursor: 'pointer' }}
                                                                        className="text-hover-warning"
                                                                        onClick={() => handleDelete(item)}
                                                                    >
                                                                        <i className="fa-regular fa-trash-can text-danger me-2"></i>
                                                                        Delete
                                                                    </p>
                                                                </div>
                                                            }
                                                            trigger="hover"
                                                        >
                                                            <button
                                                                className="btn"
                                                            >
                                                                <i className="fa-solid fa-ellipsis-vertical"></i>
                                                            </button>
                                                        </Popover>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <p>No Data Available</p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                            </table>
                            <div className="dt-paging paging_simple_numbers">
                                <nav aria-label="pagination">
                                    <ul className="pagination">
                                        <li
                                            className={`dt-paging-button page-item ${currentPage === 1 ? "disabled" : ""}`}
                                        >
                                            <button
                                                className="page-link previous"
                                                role="link"
                                                type="button"
                                                aria-controls="kt_customers_table"
                                                aria-disabled={currentPage === 1}
                                                aria-label="Previous"
                                                onClick={handlePrevious}
                                            >
                                                <i className="previous"></i>
                                            </button>
                                        </li>

                                        {/* Page Numbers */}
                                        {getPaginationNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`dt-paging-button page-item ${page === currentPage ? "active" : ""}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    role="link"
                                                    type="button"
                                                    aria-controls="kt_customers_table"
                                                    aria-current={page === currentPage ? "page" : undefined}
                                                    onClick={() => handlePageClick(page)}
                                                    disabled={page === "..."}
                                                >
                                                    {page}
                                                </button>
                                            </li>
                                        ))}

                                        {/* Next Button */}
                                        <li
                                            className={`dt-paging-button page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                            <button
                                                className="page-link next"
                                                role="link"
                                                type="button"
                                                aria-controls="kt_customers_table"
                                                aria-disabled={currentPage === totalPages}
                                                aria-label="Next"
                                                onClick={handleNext}
                                            >
                                                <i className="next"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                    {currentRecords?.map(item => (
                        <div
                            key={`modal-${item.Id}`}
                            className="modal fade"
                            id={`imageModal-${item.Id}`}
                            tabIndex="-1"
                            aria-labelledby={`imageModalLabel-${item.Id}`}
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-dialog-centered modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id={`imageModalLabel-${item.Id}`}>
                                            Image Preview
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body text-center">
                                        <img
                                            src={`${BASE_IMAGE_API_URL}${item.ImageUrl1}`}
                                            alt="Enlarged"
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '70vh',
                                                borderRadius: '10px',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <AddContentByType />
                <ViewContentByType viewObj={viewData} />
                <EditContentByType editObj={editData} />
            </div> 
        </MainLayout>
    )
}